// 存放常量
export const SUCCESS = 200;
export const DONE = 0;
export const NEED_LOGIN = 401;

// 请求时需要携带的tokenteacher
export const LOCAL_STORAGE_KEY_TOKEN = "token";
export const LOCAL_STORAGE_KEY_ROLE = "teacher";
// 注册用户请求时需要携带的手机号和验证码
export const LOCAL_STORAGE_KEY_REGISTER_PHONE = "register_phone";
export const LOCAL_STORAGE_KEY_REGISTER_CODE = "register_code";
//判断当前是什么客户端
export function deviceType() {
    let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
    var ua = window.navigator.userAgent.toLowerCase();
    // ua.indexOf('micromessenger')为真-微信端，如果为假，就是其他浏览器
    if (flag || ua.indexOf('micromessenger') > -1) {
        return "wap"; // 是微信端
    } else {
        return "PC";
    }
}
//判断当前是什么客户端
export function deviceSystem() {
    var ua = window.navigator.userAgent.toLowerCase();
    // ua.indexOf('micromessenger')为真-微信端，如果为假，就是其他浏览器
    if (ua.indexOf('micromessenger') > -1) {
      return "weixin"; // 是微信端
    } else {
      return "other";
    }
}